import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { SalesChannelService } from 'app/shared/salesChannel/sales-channel.service'
import { Fare } from 'app/fares/fares.interfaces'
import { Observable } from 'rxjs'
import { ResourceService } from 'app/shared/resources/resource.service'
import { QuoteChanged, PriceSpecificationType, QuoteLine, UserQuoteDetails } from 'app/shared/quote/quote.events'
import { IFlowReservation } from 'app/shared/steps/step.model'
import { EnvironmentService } from 'app/environment.service'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { toParamsObj } from 'app/shared/utils'
import { LocalDateTime } from 'js-joda'

@Injectable()
export class FaresService {

    private orchestationUrl

    constructor(
        private http: HttpClient,
        private authHttp: AuthHttpService,
        private salesChannelService: SalesChannelService,
        private resourceService: ResourceService,
        private environmentService: EnvironmentService
    ) {
        this.orchestationUrl = this.environmentService.getOrchestrationUrl()
    }

    public getFaresAmendment(outboundDepartureDate: LocalDateTime, returnDepartureDate: LocalDateTime, reservationCode: string): Observable<any> {
        let params = {
            'outboundDepartureDate': outboundDepartureDate,
            'returnDepartureDate': returnDepartureDate,
            'reservationCode': reservationCode
        }

        const url = `${this.orchestationUrl}/fares-amendment`
        return this.authHttp.get<Fare.IWire>(url, { params: toParamsObj(params) })
    }

    public getFaresFlow(oDate: LocalDateTime, rDate: LocalDateTime, reservation: IFlowReservation): Observable<Fare.IWire> {
        let params = {
            'outboundDepartureDate': oDate,
            'returnDepartureDate': rDate,
            'outboundRouteCode': reservation.outboundRouteId,
            'returnRouteCode': reservation.returnRouteId && reservation.returnRouteId.toLowerCase() === 'one_way' ? null : reservation.returnRouteId,
            'salesOwnerId': this.resourceService.getSalesOwner(),
            'localeCode': this.resourceService.getLocale(),
            'salesChannelCode': this.salesChannelService.getCode(),
            'adults': (<any>reservation).adults,
            'children': (<any>reservation).children,
            'infants': (<any>reservation).infants,
            'pets': (<any>reservation).pets,
            'isAmendment': 'false',
            'productCode': reservation.productCode,
            'agentGenericId': localStorage.getItem('sbw_AgentGenericId'),
        }

        if ((<any>reservation).vehicleAndTrailerTypes.length !== 0) {
            params['vehicleType'] = (<any>reservation).vehicleAndTrailerTypes[0].vehicleType
            params['trailerType'] = (<any>reservation).vehicleAndTrailerTypes[0].trailerType
        }

        const url = `${this.orchestationUrl}/fares-flow`
        return this.http.get<Fare.IWire>(url, { params: toParamsObj(params) })
    }

    public GetQuoteModel(msg: Fare.IFareChangedMessage): QuoteChanged {
        let out = msg.out && new UserQuoteDetails([new QuoteLine(msg.out.product, msg.out.price, msg.currency, 1)],
            null, msg.out.route, msg.out.departureTime.toString())

        let ret = msg.return && new UserQuoteDetails([new QuoteLine(msg.return.product, msg.return.price, msg.currency, 1)],
            null, msg.return.route, msg.return.departureTime.toString())

        return new QuoteChanged(PriceSpecificationType.Fares, out, ret, null)
    }

    public postHybridFares(postModel: Fare.IFaresPostRequest): Observable<Fare.IFaresFlowResult> {
        return this.http.post<Fare.IFaresFlowResult>(`${this.orchestationUrl}/fares-flow`, postModel)
    }

}
